import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../styles';
import { ArrowLink, Container, Heading, HtmlContent } from './ui';
import CaseStudyList from './CaseStudyList';

const StyledFeaturedCaseStudies = styled.section`
  ${sectionMargins('45px', '90px')};
`;

const StyledHeader = styled.header`
  max-width: 880px;
  text-align: center;
  margin: 0 auto 20px;

  ${minBreakpointQuery.small`
    margin-bottom: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 40px;
  `}
`;

const StyledHeading = styled(Heading)`
  text-align: center;
`;

const StyledText = styled(HtmlContent)`
  margin-top: 20px;

  ${minBreakpointQuery.small`
    margin-top: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 40px;
  `}
`;

const StyledLink = styled(ArrowLink)`
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  ${minBreakpointQuery.small`
    margin-top: 30px;
  `}
`;

const FeaturedCaseStudies = ({ heading, text, items: initialItems }) => {
  const {
    datoCmsCaseStudyListing: { slug },
    allDatoCmsCaseStudy: { nodes },
  } = useStaticQuery(graphql`
    query FeaturedCaseStudiesQuery {
      datoCmsCaseStudyListing {
        slug
      }
      allDatoCmsCaseStudy(sort: { position: ASC }, limit: 2) {
        nodes {
          ...CaseStudyCardFragment
        }
      }
    }
  `);

  const items = initialItems && initialItems.length > 0 ? initialItems : nodes;

  return (
    <StyledFeaturedCaseStudies>
      <Container>
        <StyledHeader>
          <StyledHeading>{heading}</StyledHeading>
          <StyledText content={text} />
        </StyledHeader>
        <CaseStudyList items={items} />
        <StyledLink to={slug}>View all case studies</StyledLink>
      </Container>
    </StyledFeaturedCaseStudies>
  );
};

export default FeaturedCaseStudies;
